var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table-column",
    {
      attrs: {
        align: _vm.coloumnHeader.align || "center",
        width: _vm.coloumnHeader.width,
        label: _vm.coloumnHeader.label,
        prop: _vm.coloumnHeader.value,
        fixed: _vm.coloumnHeader.fixed,
        "header-align": "center",
        "show-overflow-tooltip":
          _vm.coloumnHeader.tooltip == false ? false : true,
        sortable: _vm.coloumnHeader.sortable || false
      }
    },
    [
      _vm._l(_vm.coloumnHeader.children, function(item) {
        return [
          item.children && item.children.length
            ? _c("EXTableColumn", {
                key: item.value,
                attrs: {
                  align: item.align || "center",
                  width: item.width,
                  "header-align": "center",
                  fixed: item.fixed,
                  "show-overflow-tooltip": item.tooltip == false ? false : true,
                  sortable: item.sortable || false,
                  "coloumn-header": item
                }
              })
            : _c("el-table-column", {
                key: item.value,
                attrs: {
                  prop: item.value,
                  align: item.align || "center",
                  width: item.width,
                  label: item.label,
                  "header-align": "center",
                  fixed: item.fixed,
                  "show-overflow-tooltip": item.tooltip == false ? false : true,
                  sortable: item.sortable || false
                }
              })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cea45e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cea45e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXTable/EXTableColumn.vue
// module id = 493
// module chunks = 0